@use 'ui/styles/core-tokens' as core;

.scheduleBackups {
  padding-top: 8px;
}
